import useAppVersion from '../hooks/useAppVersion.js';

/**
 * 頂欄版號 —— 所有登入帳號都看得到。
 * 原本寄生在 SystemWarnings 徽章裡，該徽章 0724 收成 super_admin 限定後版號就跟著消失
 * （且 super_admin 會被導去 /admin，等於全帳號都看不到）→ 拆成獨立元件。
 */
export default function VersionBadge() {
    const ver = useAppVersion();
    if (!ver?.version) return null;

    const tip = [
        ver.sha ? `sha ${ver.sha}` : null,
        ver.deployedAt ? new Date(ver.deployedAt).toLocaleString() : null,
        ver.staging ? 'staging' : null,
        ver.dirty ? 'dirty' : null,
    ].filter(Boolean).join(' · ');

    const cls = 'font-mono text-[11px] text-ink-400 tabular-nums';
    // 這個版號在 Firestore releaseLinks 有設連結（/version 帶回 link）→ 底線＋新分頁；沒設就維持純文字
    const link = typeof ver.link === 'string' && ver.link.startsWith('https://') ? ver.link : null;
    if (link) {
        return (
            <a
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                title={tip || undefined}
                className={`${cls} underline underline-offset-2 hover:text-ink-600`}
            >
                v{ver.version}
            </a>
        );
    }
    return (
        <span title={tip || undefined} className={`${cls} select-none`}>
            v{ver.version}
        </span>
    );
}
